import styled from 'styled-components';

export const LocationSearchContentWrapper = styled.div`
  position: relative;

  & > div {
    height: 100%;
  }
`;

export const LocationItemsList = styled.div`
  width: 100%;
  max-height: 257px;
  overflow: auto;
  margin: 5px;
  border-radius: 8px;
  ::-webkit-scrollbar {
    width: 5px;
    background-color: ${({ theme }) => theme.palette.gray};
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: ${({ theme }) => theme.palette.brownishGrey};
  }
`;

export const LocationListItem = styled.button`
  width: 100%;
  height: 50px;
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.black};
  cursor: pointer;
  transition: all 0.4s;
  display: flex;
  align-items: flex-start;
  position: relative;
  border: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover .location-list-item-layer {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: rgba(250, 87, 81, 0.1);
  }

  &.highlighted .location-list-item-layer {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    background-color: rgba(250, 87, 81, 0.1);
  }
`;

export const LocationListItemText = styled.span`
  margin-left: 18px;
`;

export const LocationListItemIcon = styled.div`
  span,
  svg,
  path {
    font-size: 24px;
  }
`;

export const LocationListItemLayer = styled.div``;

export const LocationAnimationErrorBox = styled.div<{ borderRadius?: string }>`
  overflow: hidden;
  border-radius: ${({ borderRadius }) => borderRadius};
  &.location-animation-error {
    border: 1px solid ${({ theme }) => theme.palette.coral};
    animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
  }

  @keyframes shake {
    10%,
    90% {
      transform: translate3d(-1px, 0, 0);
    }

    20%,
    80% {
      transform: translate3d(2px, 0, 0);
    }

    30%,
    50%,
    70% {
      transform: translate3d(-4px, 0, 0);
    }

    40%,
    60% {
      transform: translate3d(4px, 0, 0);
    }
  }
`;
